module.exports = __webpack_public_path__ + "static/media/nfh-marketplace-logo.5357adf1.png";